// // src/constants/metricFields.js

// src/constants/metricFields.js
export const METRIC_FIELDS = [
  //
  // LIQUIDITY
  //
  { value: "currentRatio", label: "Current Ratio" },
  { value: "quickRatio", label: "Quick Ratio" },
  { value: "cashRatio", label: "Cash Ratio" },

  //
  // PROFITABILITY
  //
  { value: "grossProfitMargin", label: "Gross Profit Margin" },
  { value: "operatingProfitMargin", label: "Operating Profit Margin" },
  { value: "netProfitMargin", label: "Net Profit Margin" },
  { value: "ebitMargin", label: "EBIT Margin" },
  { value: "ebitdaMargin", label: "EBITDA Margin" },
  { value: "pretaxProfitMargin", label: "Pre-Tax Profit Margin" },

  //
  // EFFICIENCY / OPERATIONS
  //
  { value: "assetTurnover", label: "Asset Turnover" },
  { value: "inventoryTurnover", label: "Inventory Turnover" },
  { value: "receivablesTurnover", label: "Receivables Turnover" },
  { value: "payablesTurnover", label: "Payables Turnover" },
  { value: "fixedAssetTurnover", label: "Fixed Asset Turnover" },
  { value: "workingCapitalTurnoverRatio", label: "Working Capital Turnover" },

  //
  // LEVERAGE & RISK
  //
  { value: "debtToAssetsRatio", label: "Debt to Assets Ratio" },
  { value: "debtToEquityRatio", label: "Debt to Equity Ratio" },
  { value: "debtToCapitalRatio", label: "Debt to Capital Ratio" },
  { value: "longTermDebtToCapitalRatio", label: "Long-Term Debt to Capital Ratio" },
  { value: "financialLeverageRatio", label: "Financial Leverage Ratio" },

  //
  // CASH FLOW
  //
  { value: "operatingCashFlowRatio", label: "Operating Cash Flow Ratio" },
  { value: "operatingCashFlowSalesRatio", label: "Operating CF / Sales" },
  { value: "freeCashFlowOperatingCashFlowRatio", label: "FCF / Operating CF" },
  { value: "operatingCashFlowPerShare", label: "Operating CF per Share" },
  { value: "freeCashFlowPerShare", label: "Free Cash Flow per Share" },

  //
  // VALUATION
  //
  { value: "priceToEarningsRatio", label: "P/E Ratio" },
  { value: "priceToSalesRatio", label: "Price to Sales Ratio" },
  { value: "priceToFreeCashFlowRatio", label: "Price to Free Cash Flow Ratio" },
  { value: "priceToOperatingCashFlowRatio", label: "Price to Operating CF Ratio" },
  { value: "priceToBookRatio", label: "Price to Book Ratio" },
  { value: "enterpriseValueMultiple", label: "EV / EBITDA" },

  //
  // PER SHARE METRICS
  //
  { value: "revenuePerShare", label: "Revenue per Share" },
  { value: "netIncomePerShare", label: "Net Income per Share" },
  { value: "cashPerShare", label: "Cash per Share" },
  { value: "bookValuePerShare", label: "Book Value per Share" },
  { value: "tangibleBookValuePerShare", label: "Tangible Book Value per Share" },
];


// export const METRIC_FIELDS = [
//     // Liquidity
//     { value: "currentRatio", label: "Current Ratio" },
//     { value: "quickRatio", label: "Quick Ratio" },
  
//     // Profitability
//     { value: "grossProfitMargin", label: "Gross Profit Margin" },
//     { value: "operatingProfitMargin", label: "Operating Profit Margin" },
//     { value: "netProfitMargin", label: "Net Profit Margin" },
  
//     // Returns
//     // { value: "returnOnAssets", label: "Return on Assets" },
//     // { value: "returnOnEquity", label: "Return on Equity" },
  
//     // Leverage
//     // { value: "debtEquityRatio", label: "Debt to Equity Ratio" },
  
//     // Cash Flow
//     { value: "freeCashFlowPerShare", label: "Free Cash Flow per Share" },
//     { value: "freeCashFlowOperatingCashFlowRatio", label: "FCF / Operating CF Ratio" },
  
//     // Valuation
//     { value: "priceToEarningsRatio", label: "Price to Earnings Ratio" },
//     { value: "priceToSalesRatio", label: "Price to Sales Ratio" },
//     // { value: "priceToFreeCashFlowsRatio", label: "Price to Free Cash Flow Ratio" }
//   ];
  